import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift } from 'lucide-react';
import { PurchaseButton } from './PurchaseButton';
export function OfferSummarySection() {
  return <section className="py-24 px-4 bg-cream" data-id="element-249">
      <div className="max-w-3xl mx-auto" data-id="element-250">
        <div className="text-center mb-10" data-id="element-251">
          <span className="font-sans text-accent text-xs font-bold tracking-[0.25em] uppercase mb-3 block" data-id="element-252">
            ✦ Resumen de tu Inversión ✦
          </span>
          <h2 className="font-serif font-bold text-3xl md:text-4xl text-primary" data-id="element-253">
            Esto es lo que recibes hoy
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-12 border-4 border-gold/40 shadow-2xl relative" data-id="element-254">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-accent to-primary text-white text-xs font-bold px-5 py-2 rounded-full shadow-lg whitespace-nowrap" data-id="element-255">
            ✨ ACCESO COMPLETO
          </div>

          <ul className="space-y-3.5 mb-8 font-sans text-sm md:text-base mt-4" data-id="element-256">
            {[{
            text: 'El Código del Cierre™ (Guía de 21 días)',
            value: '$27',
            isBonus: false
          }, {
            text: 'Plan de Acción de 21 Días',
            value: '$19',
            isBonus: false
          }, {
            text: 'Kit de 21 Frases de Cierre',
            value: '$11',
            isBonus: false
          }, {
            text: 'BONO 1: Protocolo de Crisis "No le escribas"',
            value: '$17',
            isBonus: true
          }, {
            text: 'BONO 2: Checklist "Limpieza de Huellas"',
            value: '$12',
            isBonus: true
          }, {
            text: 'Garantía incondicional de 7 días',
            value: '✓',
            isBonus: false
          }, {
            text: 'Acceso digital inmediato',
            value: '✓',
            isBonus: false
          }].map((item, i) => <li key={i} className="flex items-center justify-between gap-3 pb-3 border-b border-soft/30 last:border-0" data-id="element-257">
                <div className="flex items-start gap-3 flex-1" data-id="element-258">
                  {item.isBonus ? <Gift className="text-gold shrink-0 mt-0.5" size={18} data-id="element-259" /> : <Check className="text-relief shrink-0 mt-0.5" size={18} data-id="element-260" />}
                  <span className={item.isBonus ? 'font-bold text-primary' : 'text-ink/85 font-medium'} data-id="element-261">
                    {item.text}
                  </span>
                </div>
                <span className="font-sans font-bold text-ink/50 text-sm shrink-0 line-through" data-id="element-262">
                  {item.value}
                </span>
              </li>)}
          </ul>

          <div className="bg-gradient-to-br from-blush to-soft/40 rounded-2xl p-6 text-center border-2 border-soft/40 mb-8" data-id="element-263">
            <p className="text-ink/70 font-sans text-sm mb-2" data-id="element-264">
              Valor total:{' '}
              <span className="font-bold text-urgency text-base line-through decoration-2" data-id="element-265">
                $86 USD
              </span>
            </p>
            <div className="flex flex-col items-center justify-center gap-1 mb-3" data-id="element-266">
              <span className="text-xs text-primary font-bold uppercase tracking-[0.2em]" data-id="element-267">
                Hoy solo:
              </span>
              <span className="font-serif font-extrabold text-5xl md:text-6xl text-primary" data-id="element-268">
                $6.99 <span className="text-2xl" data-id="element-269">USD</span>
              </span>
            </div>
            <span className="bg-relief text-white font-bold text-xs px-4 py-1.5 rounded-full inline-block" data-id="element-270">
              AHORRAS 92%
            </span>
          </div>

          <div className="flex justify-center" data-id="element-271">
            <PurchaseButton text="SÍ, QUIERO VOLVER A MÍ" data-id="element-272" />
          </div>
        </motion.div>
      </div>
    </section>;
}